import type { vendorApiNames } from '../names';
import type { UsernamePasswordAuthentication } from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  PaginationSettings,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

/**
 * Cisco APIC API settings available from API
 */
export type PublicCiscoApicApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['ciscoapic']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  VendorApiSessionSettings &
  VendorApiHttpAdvancedSettings &
  PaginationSettings;

/**
 * Cisco APIC API settings available in backend
 */
export type CiscoApicApiSettings = PublicCiscoApicApiSettings &
  UsernamePasswordAuthentication;

/**
 * Cisco APIC API settings expected on API when updating
 */
export type UpdateCiscoApicApiSettings = BaseUpdateVendorApiSettings<
  PublicCiscoApicApiSettings,
  UsernamePasswordAuthentication
>;
